import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { Icon, Row, Col } from "antd";

import { setCemetery } from "../../redux/actions";
import { cemeteries, oliwa, srebrzysko, lostowice } from "../../constants";

import "antd/dist/antd.css";

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMyLoc: undefined,
      loc: undefined,
      showBorder:
        window.location.pathname !== "/about-app" &&
        window.location.pathname !== "/about-project",
    };
  }

  componentDidMount() {
    this.setState({ loc: this.props.location.pathname.split("/")[1] });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showMyLoc !== this.state.showMyLoc) {
      this.props.onShowMyLoc();
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ loc: this.props.location.pathname.split("/")[1] });
    }
    if (
      ((this.props.location.pathname === "/about-project" &&
        prevProps.location.pathname !== "/about-project") ||
        (this.props.location.pathname === "/about-app" &&
          prevProps.location.pathname !== "/about-app")) &&
      this.state.showBorder
    ) {
      this.setState({ showBorder: false });
    } else if (
      !this.state.showBorder &&
      this.props.location.pathname !== "/about-project" &&
      this.props.location.pathname !== "/about-app"
    ) {
      this.setState({ showBorder: true });
    }

    if (
      this.props.location.pathname.includes(oliwa.var) &&
      this.props.data &&
      this.props.data.name !== oliwa.var
    ) {
      this.props.dispatch(setCemetery(oliwa.var));
    } else if (
      this.props.location.pathname.includes(srebrzysko.var) &&
      this.props.data &&
      this.props.data.name !== srebrzysko.var
    ) {
      this.props.dispatch(setCemetery(srebrzysko.var));
    } else if (
      this.props.location.pathname.includes(lostowice.var) &&
      this.props.data &&
      this.props.data.name !== lostowice.var
    ) {
      this.props.dispatch(setCemetery(lostowice.var));
    }
  }

  render() {
    const images = {
      [srebrzysko.var]: "/images/logozn-violet.svg",
      [oliwa.var]: "/images/logozn-brown.svg",
      [lostowice.var]: "/images/logozn-orange.svg",
    };

    return (
      <div
        className={`topbar-container ${
          this.state.showBorder ? "with-border" : ""
        }`}>
        <Row type='flex' justify='space-around' align='middle' gutter={24}>
          <Col xs={18} sm={17} md={8}>
            <NavLink to={"/"}>
              <img
                className='left'
                src={images[this.props.data.name]}
                alt='logo'
              />
            </NavLink>
          </Col>
          <Col xs={6} sm={7} md={16}>
            <div className='right'>
              {this.props.data && this.props.data.currentPosInBounds ? (
                <Icon
                  onClick={() =>
                    this.setState({ showMyLoc: !this.state.showMyLoc })
                  }
                  style={{ fontSize: 26 }}
                  className='loc'
                  size=''
                  type='environment'
                />
              ) : (
                ""
              )}

              <div onClick={() => this.props.onMenuToggle()} className='menu'>
                |||
              </div>

              <ul className='menu-desktop'>
                {cemeteries.map((cemetary) => (
                  <li
                    key={cemetary.var}
                    className={`with-submenu ${cemetary.color} ${
                      cemetary.var === this.props.data.name ? "selected" : ""
                    }`}>
                    {cemetary.name}
                    <img
                      src={`/images/arrow-${cemetary.color}.svg`}
                      alt='arrow'
                    />
                    <ul className='menu-desktop__submenu'>
                      <li>
                        <NavLink to={`/${cemetary.var}/list`}>OSOBY </NavLink>
                      </li>

                      <li>
                        <NavLink to={`/${cemetary.var}/paths`}>ŚCIEŻKI</NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`/${cemetary.var}/my-paths/${localStorage.getItem(
                            "hash"
                          )}`}>
                          MOJA ŚCIEŻKA
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                ))}

                <li>
                  <NavLink to='/about-project'>O PROJEKCIE </NavLink>
                </li>
                <li>
                  <NavLink to='/about-app'>O APLIKACJI</NavLink>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withRouter(connect(mapStateToProps)(TopBar));



// WEBPACK FOOTER //
// ./src/js/components/top-bar/index.js